export class FieldAnalysisReportDto {
  // axiosInterceptors.js deep-transforms every response's keys from snake_case
  // to camelCase before this ever runs, so the raw ML service field names
  // (field_health, likely_causes, suggested_timing, ...) already arrive as
  // fieldHealth, likelyCauses, suggestedTiming, etc.
  static fromApi(data) {
    return {
      disclaimer: data?.disclaimer || null,
      analysisDate: data?.analysisDate ?? null,
      score: data?.fieldHealth?.score ?? null,
      status: data?.fieldHealth?.status ?? null,
      summary: data?.fieldHealth?.summary ?? "",
      report: data?.report ?? "",
      likelyCauses: (data?.likelyCauses ?? []).map((item) => ({
        cause: item?.cause ?? "",
        reason: item?.reason ?? "",
        confidence: item?.confidence ?? null,
      })),
      relatedAlerts: (data?.alertsReview ?? [])
        .filter((item) => item?.supported)
        .map((item) => ({
          type: item?.type ?? "",
          reason: item?.reason ?? "",
        })),
      weatherAnalysis: data?.weatherAnalysis
        ? {
            explanation: data.weatherAnalysis.explanation ?? "",
            dominantCondition: data.weatherAnalysis.dominantCondition ?? null,
            weatherStressPresent: Boolean(
              data.weatherAnalysis.weatherStressPresent
            ),
          }
        : null,
      newRecommendations: (data?.newRecommendations ?? []).map((item) => ({
        title: item?.title ?? "",
        reason: item?.reason ?? "",
        priority: item?.priority ?? null,
        instructions: item?.instructions ?? "",
        suggestedTiming: item?.suggestedTiming ?? "",
      })),
      actionsReview: (data?.actionsReview ?? []).map((item) => ({
        id: item?.id ?? null,
        title: item?.title ?? "",
        reason: item?.reason ?? "",
        priority: item?.priority ?? null,
        assessment: item?.assessment ?? null,
        instructions: item?.instructions ?? "",
        suggestedTiming: item?.suggestedTiming ?? "",
      })),
      additionalDataNeeded: data?.additionalDataNeeded ?? [],
    };
  }
}
